import React from "react";
import { formatDate } from "./helpers";
import { resolveBookingRequirementText } from "../../../../../utils/viewDetailsBuilders";

import { shouldShowFloatRequirement } from "./hourlyFloatHelpers";

const BookingInfoHeader = ({ booking, showRequirement }) => {
    const requirementText = resolveBookingRequirementText(booking);
    const showReq =
        showRequirement !== undefined
            ? showRequirement
            : shouldShowFloatRequirement(booking);

    return (
        <div className="hourly-float-photographer-modal-header float-photographer-modal-header">
            <h3>Float Booking</h3>

            <div className="booking-info-grid">
                <InfoItem label="Booking ID"  value={booking?.veroaBookingId || booking?.bookingId} />
                <InfoItem label="Client"      value={booking?.clientName || booking?.client_id?.username} />
                <InfoItem label="Event Date"  value={formatDate(booking?.bookingDate || booking?.eventDate || booking?.date)} />
                <InfoItem label="Location"    value={booking?.eventAddress || booking?.location || booking?.address} />
                <InfoItem label="Amount"      value={(booking?.finalAmount || booking?.totalAmount || booking?.bookingAmount) ? `₹ ${(booking.finalAmount || booking.totalAmount || booking.bookingAmount).toLocaleString()}` : null} />
                {showReq && requirementText ? (
                    <InfoItem label="Requirement" value={requirementText} />
                ) : null}
            </div>
        </div>
    );
};

const InfoItem = ({ label, value }) => (
    <div className="booking-info-item">
        <span>{label}</span>
        <p>{value || "-"}</p>
    </div>
);

export default BookingInfoHeader;
